/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const CreateEditDtoSourceTypeEnum = {
    FRAGMENT: "FRAGMENT"
} as const;

export type CreateEditDtoSourceTypeEnumKey = (typeof CreateEditDtoSourceTypeEnum)[keyof typeof CreateEditDtoSourceTypeEnum];

export const CreateEditDtoSourceTypeEnum2 = {
    COMPOSITION: "COMPOSITION"
} as const;

export type CreateEditDtoSourceTypeEnum2Key = (typeof CreateEditDtoSourceTypeEnum2)[keyof typeof CreateEditDtoSourceTypeEnum2];

export type CreateEditDto = (({
    /**
     * @type string
    */
    sourceType: CreateEditDtoSourceTypeEnumKey;
    /**
     * @type string, uuid
    */
    sourceId: string;
    /**
     * @minLength 1
     * @type string
    */
    name: string;
    /**
     * @type object | undefined
    */
    config?: {
        /**
         * @type string | undefined, uri
        */
        videoUrl?: string;
        /**
         * @type string | undefined, uri
        */
        captionsUrl?: string;
    };
} & {
    sourceType: "FRAGMENT";
}) | ({
    /**
     * @type string
    */
    sourceType: CreateEditDtoSourceTypeEnum2Key;
    /**
     * @type string, uuid
    */
    sourceId: string;
    /**
     * @minLength 1
     * @type string
    */
    name: string;
    /**
     * @type object | undefined
    */
    config?: {
        /**
         * @type string | undefined, uri
        */
        videoUrl?: string;
        /**
         * @type string | undefined, uri
        */
        captionsUrl?: string;
    };
} & {
    sourceType: "COMPOSITION";
}));